const latestArticlesCards = document.querySelectorAll('#latest-articles__slider .keen-slider__slide');

if (latestArticlesCards.length > 1) {

  // Prevent click event when dragging
  var drag = false;

  // Allow more than one slider at the same time
  document.querySelectorAll('#latest-articles__slider').forEach(slider => { 
    new KeenSlider(slider, {
      dragChecked() {
        drag = true;
      },
      dragEnded() {
        setTimeout(() => (drag = false), 0);
      },
      created() {
        document.querySelectorAll('#latest-articles__slider').forEach(slider => {
          slider.addEventListener("click", (e) => {
            if (drag) {
              e.stopPropagation();
              e.preventDefault();
            }
          })
        });
      },
      breakpoints: {
        '(max-width: 449px)': {
          slides: {
            perView: 1.5,
            spacing: 16
          }
        },
        '(min-width: 450px) and (max-width: 749px)': {
          slides: {
            perView: 1.5,
            spacing: 20
          }
        },
        '(min-width: 750px) and (max-width: 989px)': {
          slides: {
            perView: 2,
            spacing: 20
          }
        },
        '(min-width: 990px)': {
          disabled: true,
        },
      },
    }, [navigation])
  })
}